import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className=" p-10 bg-neutral text-neutral-content">
            <div className='container mx-auto'>
                <div className="footer">
                    <div>
                        <span className="footer-title">Cataghory</span>
                        <Link className="link link-hover">Iphone</Link>
                        <Link className="link link-hover">samsung</Link>
                        <Link className="link link-hover">One Plus</Link>
                        <Link className="link link-hover">Advertisement</Link>
                    </div>
                    <div>
                        <span className="footer-title">Company</span>
                        <Link className="link link-hover">About us</Link>
                        <Link className="link link-hover">Contact</Link>
                        <Link className="link link-hover">Recent product</Link>
                        <Link className="link link-hover">high level product</Link>
                    </div>
                    <div>
                        <span className="footer-title">Legal</span>
                        <Link className="link link-hover">Terms of use</Link>
                        <Link className="link link-hover">Privacy policy</Link>
                        <Link className="link link-hover">Cookie policy</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;